import React, { useRef } from "react";
import { BiImageAdd } from "react-icons/bi";
import { BsExclamationCircleFill } from "react-icons/bs";
import { FcAddImage } from "react-icons/fc";
import { IoAddOutline } from "react-icons/io5";
import DefaultPic from "../../assets/images/DefaultProfilePic.jpg";

const ProfileImageUpload = ({
  filesHandler,
  files,
  imageUrl,
  imageUrlHandler,
}) => {
  const hiddenFileInput = useRef(null);
  const handleClick = (e) => {
    hiddenFileInput.current.click();
  };

  function handleImageChange(e) {
    filesHandler(e.target.files[0]);
    imageUrlHandler(URL.createObjectURL(e.target.files[0]));
  }
  return (
    <div className="upload-profile-img-wrapper">
      <div className="update-profile-edit-btn" onClick={handleClick}>
        <IoAddOutline className="profile-icon  cursor-pointer" />
      </div>
      <div className="profile-img-box ">
        <img
          src={imageUrl ? imageUrl : DefaultPic}
          alt="profile picture"
          className="profile-image"
        />
      </div>
      <div>
        <input
          id="image-upload-input"
          type="file"
          onChange={handleImageChange}
          ref={hiddenFileInput}
          className="image-upload-input"
          accept="image/png , image/jpeg, image/webp"
        />
      </div>
    </div>
  );
};

export default ProfileImageUpload;
